<template>
  <div class="storage">
    <el-form
      class="custom-formScreen"
      :model="formScreen"
      ref="formScreen"
      label-width="4.8vw"
      inline
    >
      <el-form-item label="开始日期" prop="startTimeString">
        <el-date-picker
          v-model="formScreen.startTimeString"
          align="right"
          type="date"
          placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTimeString">
        <el-date-picker
          v-model="formScreen.endTimeString"
          align="right"
          type="date"
          placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        ></el-date-picker>
      </el-form-item>
      <template>
        <el-form-item label="类型" prop="operateType">
          <el-select v-model="formScreen.operateType">
            <el-option
              v-for="item in GoodsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label=" " prop="searchString" style="width: 40%">
        <el-input
          v-model="formScreen.searchString"
          placeholder="全字段搜索"
          style="width: calc(100% - 140px);"
        ></el-input>
        <el-button type="primary" style="margin-left: 10px;" @click="search">搜索</el-button>
        <el-button type="primary" @click="resetFprm('formScreen')">重置</el-button>
      </el-form-item>
    </el-form>
    <el-button type="primary" style="margin-bottom:15px;" @click="downExcel">出入库记录导出</el-button>

    <!-- 出入库记录表格 -->
    <el-table :data="listTable3"  border style="width: 100%" v-loading="loading">
      <el-table-column width="200" label="库存编号/订单号" align="center">
          <template slot-scope="scope">
            <p>{{scope.row.inventoryNumber}}</p>
            <p>{{scope.row.amazonOrderId}}</p>
          </template>
      </el-table-column>
      <el-table-column label="图片" width="120" align="center">
        <template slot-scope="scope">
          <el-popover
            trigger="hover"
            placement="right"
            style="float: left"
            v-if="scope.row.imagesList"
          >
            <img :src="scope.row.imagesList[0]" class="prduct_img" alt />
            <div class="scope_img" slot="reference">
              <img :src="scope.row.imagesList[0]" alt />
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="数量" min-width="80" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">{{scope.row.actualCount}}</div>
          <div v-if="scope.row.operateType === 2">{{scope.row.useCount}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="productFullName" min-width="200" label="全称" align="center"></el-table-column>
      <el-table-column prop="averageWeight" width="100" label="平均计费重" align="center"></el-table-column>
      <el-table-column prop="productType" width="100" label="货物类型" align="center"></el-table-column>
      <el-table-column width="100" label="类型" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.operateType === 1">入库</div>
          <div v-else-if="scope.row.operateType === 2">出库</div>
          <div v-else-if="scope.row.operateType === 3">销毁</div>
        </template>
      </el-table-column>
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="confirmTime" width="200" label="出入库时间" align="center"></el-table-column>
      <el-table-column prop="createTime" width="200" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" width="200" label="更新时间" align="center"></el-table-column>
      <el-table-column width="100" label="操作" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="BarCode(scope.row)">打印</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-row type="flex" justify="center" align="middle" class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100, 200, 400]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>

  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "@/api/api/api";

export default {
  name: "Storage",
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      loading:true,
      formScreen: {
        startTimeString: "",
        endTimeString: "",
        searchString: "",
        operateType: '',
        branchCompanyId: '',
        companyId: '',
        warehouseName: '',
        shelfType: ''
      },
      listBranch: [],
      listSon: [],
      listTable: [],
      listTable2: [],
      listTable3: [],
      listWarehouse: [], //仓库
      listShelves: [], //货架
      Operatorlist: [],
      GoodsType: [
        { value: '1', label: '入库' },
        { value: '2', label: '出库' },
        { value: '3', label: '销毁' },
      ]
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.search()
  },
  methods: {
    search() {
      this.page = 1
      this.getListTable3()
    },
    resetFprm(formName) {
      this.page = 1
      this.$refs[formName].resetFields();
      this.getListTable3()
    },
    handleSizeChange(val) {
        this.size = val
        this.getListTable3()
    },
    handleCurrentChange(val) {
        this.page = val
        this.getListTable3()
    },
    getListTable3() {
      this.loading = true
      const API = Baseurl + "inventoryController/selectInventoryOperateHistory";
      const { 
        startTimeString,
        endTimeString,
        searchString,
        operateType} = this.formScreen
      const paramsData = {
        page: this.page,
        size: this.size,
        startTimeString,
        endTimeString,
        companyId:this.UserInfo.company_id,
        searchString,
        operateType
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          data.list.forEach(item => (item.averageWeight = Number(item.averageWeight).toFixed(2)));
          this.listTable3 = data.list;
          this.total = data.total;
        }
        this.loading = false
      });
    },
    downExcel:function(){
            const { 
              startTimeString,
              endTimeString,
              branchCompanyId,
              searchString,
              operateType } = this.formScreen
            const paramsData = {
              startTimeString,
              endTimeString,
              branchCompanyId,
              companyId:this.UserInfo.company_id,
              searchString,
              operateType
            };
            const API = Baseurl + "inventoryController/exportInventoryOperateHistory";
            // const headers = {headers:'application/x-download'};
            const blobs = { responseType: 'blob'}
            this.$http.post(API,paramsData,blobs).then(response => {
                const blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
            //第一种
                const fileName = '出入库记录.xls';
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
                //        第二种  
                //   const url = URL.createObjectURL(blob);
                //     window.location.href = url;
                //    window.location.href = response.data;
            })
    },
    BarCode(val){
        const API = Baseurl + "inventoryPdfPrintController/pdfPrint";
        const paramsData = { id:val.id};
        ajaxPost(API, paramsData).then(res => {
            window.open(res.data.data, '_blank');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.storage {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
.scope_img {
  img {
    width: 100px;
    height: 100px;
  }
}
.prduct_img {
  width: 500px;
  height: 500px;
}
</style>
